import { GoalFilterDocument, UserSettings } from '@griply/types';

import { defaultProjectsOverviewFilterDocument } from './constants/default-projects-overview-filter-document';

export const buildProjectsOverviewFilterDocument = (
  settings: UserSettings | undefined,
): GoalFilterDocument => ({
  ...defaultProjectsOverviewFilterDocument,
  ...(settings?.filters?.projectsOverview ?? {}),
});
